import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';

export default class ConversationList extends Component {
  view() {
    const { rows, selected, onSelect } = this.attrs;
    return m('div.MessageConversationList', rows.length ? rows.map(row => m('button.MessageConversationList-item', {
      className: String(selected) === String(row.id) ? 'is-selected' : '',
      onclick: () => onSelect(row.id),
    }, [m('strong', row.recipient.nickname), row.unread_count > 0 && m('span.Button-badge', row.unread_count > 99 ? '99+' : row.unread_count),
      m('p', row.last_message?.body || app.translator.trans('yingtao-forum-homepage.forum.private_messages.empty_messages'))]))
      : m('p', app.translator.trans('yingtao-forum-homepage.forum.private_messages.empty_conversations')));
  }
}
